import React from 'react';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import cn from 'classnames';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {stripHtmlWithSpaces} from 'utils/stripHtml';
import {List, Set} from 'immutable';
import TextField from '@material-ui/core/TextField';
import {Library} from '@store/@types/records/Library';
import {CommentId, UserComment} from 'records/UserComment';
import {SetState} from '@store/@types/util/React';
import './LibraryHighlightSelect.scss';

interface LibraryHighlightSelectProps {
  library: Library | null;
  userHighlights: List<UserComment>;
  isFullCall: boolean;
  hasOtherUserHighlights: boolean;
  setFullCallSelected: SetState<boolean>;
  selectedHighlights: Set<CommentId>;
  setSelectedHighlights: SetState<Set<CommentId>>;
}

export const LibraryHighlightSelect: React.FC<LibraryHighlightSelectProps> = ({
  hasOtherUserHighlights,
  isFullCall,
  library,
  selectedHighlights,
  setFullCallSelected,
  setSelectedHighlights,
  userHighlights,
}) => {
  if (!library || userHighlights.isEmpty()) return null;

  return (
    <div className="library-highlight-select">
      <div className="is-full-call-radio-group">
        <RadioGroup>
          <div>
            <Radio
              checked={isFullCall}
              disabled={hasOtherUserHighlights}
              onChange={() => setFullCallSelected(true)}
            />
            <label className={cn({disabled: hasOtherUserHighlights})}>
              Is Full Call
              {hasOtherUserHighlights &&
                ' (disabled because other users have added this call with highlights)'}
            </label>
          </div>
          <div>
            <Radio checked={!isFullCall} onChange={() => setFullCallSelected(false)} />
            <label>Selected Highlights</label>
          </div>
        </RadioGroup>
      </div>
      {!isFullCall && (
        <>
          <Autocomplete
            multiple
            filterSelectedOptions
            getOptionLabel={opt => stripHtmlWithSpaces(opt!.message)}
            getOptionSelected={(option, value) => option?.id === value?.id}
            options={userHighlights.toJS()}
            value={selectedHighlights.toJS().map(sh => userHighlights.find(h => h.id === sh)!)}
            onChange={(e, highlights) => {
              setSelectedHighlights(Set(highlights.map(h => h.id!)));
            }}
            renderInput={params => (
              <TextField
                className="library-tab-select-input highlight-select"
                {...params}
                size="small"
                fullWidth={false}
                variant="outlined"
                error={selectedHighlights.isEmpty()}
              />
            )}
          />
          {selectedHighlights.isEmpty() && (
            <p className="empty-highlights">
              Please specify at least one highlight or choose Add Full Call
            </p>
          )}
        </>
      )}
    </div>
  );
};
